import React from "react";
import "./styles/CiDownload.scss";
import { useTranslation } from "react-i18next";

const CiDownload = () => {
  const { t } = useTranslation();
  const handleDownload = (path: string) => {
    window.location.href = path;
  };
  return (
    <>
      <div className="ci_download_wrap">
        <h2>{t("aboutUs.ci.download.title")}</h2>
        <div className="inner">
          <div className="content">
            <div className="img_box">
              <img src="/imgs/ci_architecogroup.png" alt="ci_architecogroup" />
            </div>
            <div className="btn_wrap">
              <button
                onClick={() => {
                  handleDownload("/download/Architeco_CI.zip");
                }}
              >
                <img src="/imgs/icon_download.png" alt="download_icon" />
                <span>{t("aboutUs.ci.download.download")}</span>
              </button>
            </div>
          </div>
          <div className="content">
            <div className="img_box">
              <img src="/imgs/ci_geodnt.png" alt="ci_geodnt" />
            </div>
            <div className="btn_wrap">
              <button
                onClick={() => {
                  handleDownload("/download/GO_BI.zip");
                }}
              >
                <img src="/imgs/icon_download.png" alt="download_icon" />
                <span>{t("aboutUs.ci.download.download")}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CiDownload;
